import _sfc_main from "./BuyBoxPup2.mjs";
/* empty css            */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const BuyBoxPup = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-6b285918"]]);
export {
  BuyBoxPup as default
};
//# sourceMappingURL=BuyBoxPup.mjs.map
